import { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../../common/page-title';
import PipEposSubmissionsSearch from './pip-epos-submissions-search';
import PipEposSubmissionsTable from './pip-epos-submissions-table';
import { getPipEposSubmissions } from '../../../../actions/pip-epos-submissions';

class PipEposSubmissionsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      weekOfSaleFrom: '',
      weekOfSaleTo: '',
      status: '',
      objectiveId: '',
      currentPage: 1
    };
  }

  componentDidMount() {
    this.setState({
      status: 'PRE-VALIDATED',
    }, this.handleSearch);
  }

  handleSearchChange = (event) => {
    this.setState({ search: event.target.value });
  };

  handleWeekOfSaleFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ weekOfSaleFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ weekOfSaleFrom: '' });
    }
  };

  handleWeekOfSaleToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ weekOfSaleTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ weekOfSaleTo: '' });
    }
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleObjectiveChange = (event) => {
    this.setState({ objectiveId: event.target.value });
  }

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      search,
      weekOfSaleFrom,
      weekOfSaleTo,
      status,
      objectiveId,
      currentPage
    } = this.state;

    dispatch(getPipEposSubmissions(search, weekOfSaleFrom, weekOfSaleTo, status, objectiveId, currentPage));
  };

  handleSearchClick = () => {
    this.setState({ currentPage: 1 }, this.handleSearch);
  }

  handleClear = () => {
    this.setState({
      search: '',
      weekOfSaleFrom: '',
      weekOfSaleTo: '',
      status: '',
      objectiveId: ''
    }, this.handleSearch);
  };

  handlePageChange = (currentPage) => {
    this.setState({ currentPage }, this.handleSearch);
  };

  render() {
    const {
      search,
      weekOfSaleFrom,
      weekOfSaleTo,
      status,
      objectiveId,
      currentPage
    } = this.state;

    return (
      <div>
        <PageTitle>
          Epos Submissions
        </PageTitle>
        <PipEposSubmissionsSearch
          search={search}
          weekOfSaleFrom={weekOfSaleFrom}
          weekOfSaleTo={weekOfSaleTo}
          status={status}
          objectiveId={objectiveId}
          onHandleSearchChange={this.handleSearchChange}
          onHandleWeekOfSaleFromChange={this.handleWeekOfSaleFromChange}
          onHandleWeekOfSaleToChange={this.handleWeekOfSaleToChange}
          onHandleStatusChange={this.handleStatusChange}
          onHandleObjectiveChange={this.handleObjectiveChange}
          onHandleSearch={this.handleSearchClick}
          onHandleClear={this.handleClear}
        />
        <PipEposSubmissionsTable
          currentPage={currentPage}
          onHandlePageChange={this.handlePageChange}
        />
      </div>
    );
  }
}

export default connect(null)(PipEposSubmissionsPage);
